"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapSearchResultsPageQueryToProductListingRows = void 0;
const mapSearchResultsPageQueryToProductListingRows = (data)=>{
    var _data_application_productSearchPage, _data_application;
    if (!((_data_application = data.application) === null || _data_application === void 0 ? void 0 : (_data_application_productSearchPage = _data_application.productSearchPage) === null || _data_application_productSearchPage === void 0 ? void 0 : _data_application_productSearchPage.products)) {
        return undefined;
    }
    const { products } = data.application.productSearchPage;
    return {
        facets: products.facets,
        orderByOptions: products.orderByOptions,
        totalBannersCount: 0,
        totalProductsCount: products.totalProductsCount,
        rows: products.rows.map((row)=>({
                __typename: 'PlpRow',
                content: row.content.filter((content)=>(content === null || content === void 0 ? void 0 : content.__typename) === 'Product')
            }))
    };
};
exports.mapSearchResultsPageQueryToProductListingRows = mapSearchResultsPageQueryToProductListingRows;
